<template>
  <b-modal
    id="multipleEditModal"
    :title="ids.length + ' ABFHT bearbeiten'"
    size="lg"
    centered
    @hidden="resetFormVariables"
    @shown="onShow"
  >
    <b-overlay :show="isBusy">
      <!-- Ursachen -->
      <b-list-group horizontal>
        <b-list-group-item
          class="col-6 d-flex align-items-center"
          style="
            background-color: rgba(114, 114, 114, 0.05);
            border-style: solid;
            border-width: 1px;
            border-color: rgba(114, 114, 114, 0.15);
          "
        >
          <h6 class="m-0 my-1">Ursachen</h6>
        </b-list-group-item>
        <b-list-group-item class="col-6 d-flex align-items-center py-0 pl-2">
          <AppSelect
            v-model="formVariables.ursacheSelected"
            sort="none"
            :options="ursachenOptions"
            text-field="label"
            value-field="enum"
            label="Ursache"
            placeholder="Ursache auswählen"
            clearable
          />
        </b-list-group-item>
      </b-list-group>
      <!-- Beschreibung -->
      <b-list-group horizontal>
        <b-list-group-item
          class="col-6 d-flex align-items-center"
          style="
            background-color: rgba(114, 114, 114, 0.05);
            border-style: solid;
            border-width: 1px;
            border-color: rgba(114, 114, 114, 0.15);
          "
        >
          <h6 class="m-0 my-1">Beschreibung</h6>
        </b-list-group-item>
        <b-list-group-item class="col-6 d-flex align-items-center p-0">
          <b-form-input
            v-model="formVariables.beschreibungText"
            class="border-0"
            style="font-size: 13px"
            placeholder="Beschreibung einfügen..."
          ></b-form-input>
          <X
            v-if="formVariables.beschreibungText"
            :size="16"
            class="text-danger ml-auto mr-5"
            @click="resetBeschreibung"
            style="cursor: pointer"
          />
        </b-list-group-item>
      </b-list-group>
      <b-list-group horizontal>
        <b-list-group-item
          class="col-6 d-flex align-items-center"
          style="
            background-color: rgba(114, 114, 114, 0.05);
            border-style: solid;
            border-width: 1px;
            border-color: rgba(114, 114, 114, 0.15);
          "
        >
          <h6 class="m-0 my-1">Status</h6>
        </b-list-group-item>
        <b-list-group-item class="col-6 d-flex align-items-center py-0 pl-2">
          <AppSelect
            v-model="formVariables.statusSelected"
            sort="none"
            :options="statusOptions"
            text-field="label"
            value-field="enum"
            label="Status"
            placeholder="Status auswählen"
            hide-search
            clearable
            @change="onStatusChange"
          />
        </b-list-group-item>
      </b-list-group>
      <!-- Lösungsansatz -->
      <b-list-group horizontal v-if="formVariables.statusSelected === 'VerfuegbarkeitGeschaffen'">
        <b-list-group-item
          class="col-6 d-flex align-items-center"
          style="
            background-color: rgba(114, 114, 114, 0.05);
            border-style: solid;
            border-width: 1px;
            border-color: rgba(114, 114, 114, 0.15);
          "
        >
          <h6 class="m-0 my-1">Lösungsansatz</h6>
        </b-list-group-item>
        <b-list-group-item class="col-6 d-flex align-items-center py-0 pl-2">
          <AppSelect
            v-model="formVariables.loesungsansatzSelected"
            sort="none"
            :options="loesungsansatzOptions"
            text-field="label"
            value-field="enum"
            label="Lösungsansatz"
            placeholder="Lösungsansatz auswählen"
            hide-search
            clearable
          />
        </b-list-group-item>
      </b-list-group>
      <!-- Akzeptanzgrund -->
      <b-list-group horizontal v-if="formVariables.statusSelected === 'Akzeptiert'">
        <b-list-group-item
          class="col-6 d-flex align-items-center"
          style="
            background-color: rgba(114, 114, 114, 0.05);
            border-style: solid;
            border-width: 1px;
            border-color: rgba(114, 114, 114, 0.15);
          "
        >
          <h6 class="m-0 my-1">Akzeptanzgrund</h6>
        </b-list-group-item>
        <b-list-group-item class="col-6 d-flex align-items-center py-0 pl-2">
          <AppSelect
            v-model="formVariables.akzeptanzgrundSelected"
            sort="none"
            :options="akzeptanzgrundOptions"
            :state="formVariables.akzeptanzgrundSelected !== null"
            text-field="label"
            value-field="enum"
            label="Akzeptanzgrund"
            placeholder="Akzeptanzgrund auswählen"
            clearable
          />
        </b-list-group-item>
      </b-list-group>
    </b-overlay>

    <template #modal-footer="{ hide }">
      <b-button class="dialog-btn-secondary" @click="hide">Abbrechen</b-button>
      <b-button
        class="dialog-btn"
        :disabled="disableSichernButton"
        variant="primary"
        @click="bulkUpdateRows(hide)"
      >
        Sichern
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import apiService from '@/core/common/services/api.service';
import {
  ursachenPossibilities,
  allUrsachen,
  akzeptanzgrundPossibilities,
  auswaehlbareAkzeptanzgruende,
} from '@/core/flugverfuegbarkeit/bearbeitungs-options.config.js';
import AppSelect from '@/components/common/app-select/app-select.vue';
import { X } from 'lucide-vue';

export default {
  components: {
    AppSelect,
    X,
  },
  props: {
    ids: { type: Array, required: true },
    stati: { type: Array, required: true },
  },
  data() {
    return {
      isBusy: false,
      formVariables: {
        ursacheSelected: null,
        loesungsansatzSelected: null,
        akzeptanzgrundSelected: null,
        beschreibungText: null,
        statusSelected: null,
      },
      ursachenOptions: [],
      statusOptions: [
        { label: 'Verfügbarkeit geschaffen', enumValue: 1, enum: 'VerfuegbarkeitGeschaffen' },
        { label: 'Verfügbarkeit nicht geschaffen', enumValue: 2, enum: 'VerfuegbarkeitNichtGeschaffen' },
        { label: 'Akzeptiert', enumValue: 3, enum: 'Akzeptiert' },
      ],
      loesungsansatzOptions: [
        { label: 'Gruppe geöffnet', enumValue: 1, enum: 'GruppeGeoeffnet' },
        { label: 'VK erhöht', enumValue: 2, enum: 'VKErhoeht' },
        { label: 'Transferslotanpassung', enumValue: 3, enum: 'Transferslotanpassung' },
        { label: 'Published Fares aktiviert', enumValue: 4, enum: 'PublishedFaresAktiviert' },
        { label: 'Restriktionsanpassung', enumValue: 5, enum: 'Restriktionsanpassung' },
        { label: 'Terminschließung', enumValue: 6, enum: 'Terminschließung' },
      ],
      akzeptanzgrundOptions: [],
    };
  },
  computed: {
    disableSichernButton() {
      const akzeptiertStatusAndAkzeptanzgrundNotSelected =
        this.formVariables?.statusSelected === 'Akzeptiert' &&
        this.formVariables?.akzeptanzgrundSelected === null;

      const noStatus = this.formVariables.statusSelected === null;

      return noStatus || akzeptiertStatusAndAkzeptanzgrundNotSelected || this.isBusy;
    },
  },
  methods: {
    onShow() {
      const rowsDistinctStatus = [...new Set(this.stati)];
      const isOnlyOneStatus = rowsDistinctStatus.length === 1;
      if (isOnlyOneStatus) {
        this.ursachenOptions = ursachenPossibilities.find(item =>
          rowsDistinctStatus.includes(item.status)
        ).options;
        this.akzeptanzgrundOptions = akzeptanzgrundPossibilities.find(item =>
          rowsDistinctStatus.includes(item.status)
        ).options;
      } else {
        this.ursachenOptions = allUrsachen;
        this.akzeptanzgrundOptions = auswaehlbareAkzeptanzgruende;
      }
    },
    // Lösungsansatz und Akzeptanzgrund hängen am Status und werden bei dessen Wechsel geleert
    onStatusChange() {
      this.formVariables.akzeptanzgrundSelected = null;
      this.formVariables.loesungsansatzSelected = null;
    },
    resetFormVariables() {
      this.formVariables = {
        ursacheSelected: null,
        loesungsansatzSelected: null,
        akzeptanzgrundSelected: null,
        beschreibungText: null,
        statusSelected: null,
      };
    },
    async bulkUpdateRows(hide) {
      const ursachen = this.formVariables.ursacheSelected || null;
      const bearbeitungStatus = this.formVariables.statusSelected || null;
      const loesungsansatz = this.formVariables.loesungsansatzSelected || null;
      const akzeptanzgrund = this.formVariables.akzeptanzgrundSelected || null;
      this.isChangingBearbeitungsData = true;

      const idLength = this.ids.length;

      const params = {
        ids: this.ids,
        ursachen,
        beschreibung: this.formVariables.beschreibungText,
        bearbeitungStatus,
        loesungsansatz,
        akzeptanzgrund,
      };

      if (bearbeitungStatus !== null || (bearbeitungStatus === 'Akzeptiert' && akzeptanzgrund !== null)) {
        this.isBusy = true;
        await apiService
          .put('flugverfuegbarkeit/bulkUpdateStatusData', params)
          .then(response => {
            console.log(response);
            this.toast(idLength + ' ABFHT wurden erfolgreich bearbeitet.');
            this.$emit('bulkUpdateSuccess');
          })
          .catch(error => {
            console.error(error);
          });
        this.isBusy = false;
      }
      hide();
    },
    resetBeschreibung() {
      this.formVariables.beschreibungText = null;
    },
  },
};
</script>
<style></style>
